import ApiService from './Api.service.js';

class MeetingService extends ApiService {
}

export default new MeetingService('meetings');



// WEBPACK FOOTER //
// ./src/services/axios/meetings.service.js